module.exports = __webpack_public_path__ + "static/media/config.86beeced.svg";